import { render, staticRenderFns } from "./component.vue?vue&type=template&id=e4dd2af2&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=e4dd2af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dd2af2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4dd2af2')) {
      api.createRecord('e4dd2af2', component.options)
    } else {
      api.reload('e4dd2af2', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=e4dd2af2&scoped=true&", function () {
      api.rerender('e4dd2af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/file/button/component.vue"
export default component.exports